import React, { useEffect, useState } from 'react';
import { useSocket } from '../contexts/socketContext';
import { useNetworkStatus } from './useNetworkStatus';

const NetworkStatus = () => {
  const { isSocketConnected } = useSocket();
  const { isOnline } = useNetworkStatus();

  const [showBanner, setShowBanner] = useState(false);
  const [connectionRestored, setConnectionRestored] = useState(false);

  const hasConnectionIssue = !isOnline || !isSocketConnected;

  useEffect(() => {
    let timeout;
    let restoredTimeout;

    if (hasConnectionIssue) {
      setConnectionRestored(false);

      if (showBanner) {
        setShowBanner(true);
      } else {
        timeout = setTimeout(() => {
          setShowBanner(true);
        }, 3000);
      }
    } else {
      if (showBanner) {
        setConnectionRestored(true);

        restoredTimeout = setTimeout(() => {
          setConnectionRestored(false);
          setShowBanner(false);
        }, 2000);
      }
    }

    return () => {
      clearTimeout(timeout);
      clearTimeout(restoredTimeout);
    };
  }, [hasConnectionIssue, showBanner]);

  if (!showBanner && !connectionRestored) {
    return null;
  }

  const message = connectionRestored
    ? 'Conexión restablecida'
    : !isOnline
      ? 'Sin conexión a internet'
      : 'Reconectando...';

  const backgroundColor = connectionRestored
    ? '#198754'
    : '#dc3545';

  return (
    <div
      role="status"
      aria-live="polite"
      className="position-fixed top-0 start-0 w-100 px-3 py-2 text-center"
      style={{
        zIndex: 9999,
        backgroundColor,
        color: '#fff',
        fontWeight: 500,
        transition: 'all 0.3s ease',
      }}
    >
      <span
        className="material-icons align-middle mr-2"
        style={{ fontSize: '18px' }}
      >
        {connectionRestored ? 'wifi' : 'wifi_off'}
      </span>

      {message}
    </div>
  );
};

export default NetworkStatus;